module.exports = __webpack_public_path__ + "assets/imgs/logos/tiktok.c62b3cb117f1496c21a9658254ad2efd.png";